import { render, staticRenderFns } from "./QSDetails.vue?vue&type=template&id=6f53b78a&scoped=true&"
import script from "./QSDetails.vue?vue&type=script&lang=js&"
export * from "./QSDetails.vue?vue&type=script&lang=js&"
import style0 from "./QSDetails.vue?vue&type=style&index=0&id=6f53b78a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f53b78a",
  null
  
)

export default component.exports